import { FC } from "react";
import { Icon } from "./Icon";

export type BreadcrumbItemProps = {
  content: string;
  onClick?: () => void;
  isLast: boolean;
};

const BreadcrumbItem: FC<BreadcrumbItemProps> = ({ content, onClick, isLast }) => {
  const color = "text-neutral-400";

  const contentClassname = [
    color,
    "select-none",
    typeof onClick === "undefined" ? "cursor-default" : "cursor-pointer hover:text-primary-200",
  ].join(" ");

  const caretClassName = `mx-5 ${color}`;

  return (
    <div onClick={onClick} className="flex flex-row items-center mx:leading-8">
      <span className={contentClassname}>{content}</span>
      {isLast ? null : (
        <span className={caretClassName}>
          <Icon name="caret-right" size={10} />
        </span>
      )}
    </div>
  );
};

export type BreadcrumbProps = {
  items: Omit<BreadcrumbItemProps, "isLast">[];
};

export const Breadcrumb: FC<BreadcrumbProps> = ({ items }) => {
  return (
    <div className="flex flex-row">
      {items.map(({ content, onClick }, index, list) => (
        <BreadcrumbItem key={index} content={content} onClick={onClick} isLast={list.length === index + 1} />
      ))}
    </div>
  );
};
